// App.js
import React, { useState } from 'react';
import AssessmentTabs from './AssessmentTabs';

function AssessmentIndex() {
   
    return (
        <AssessmentTabs />
    );
}

export default AssessmentIndex;
